import { render, staticRenderFns } from "./Propriedade.vue?vue&type=template&id=20616ea8"
import script from "./Propriedade.vue?vue&type=script&lang=js"
export * from "./Propriedade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports